import {
  NgModule
} from '@angular/core';

import {
  CommonModule
} from '@angular/common';

import {
  FormContactBoxComponent
} from './form-contact-box.component';

import {
  FormContactBoxEuComponent
} from './form-contact-box-eu.component';

@NgModule({
  declarations: [
    FormContactBoxComponent,
    FormContactBoxEuComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    FormContactBoxComponent,
    FormContactBoxEuComponent
  ],
  providers: [
  ]
})
export class FormElementsModule {}